<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle}}</span>
      <button (click)="dialogRef.close()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" eguardPerfectScrollbar>
    <div>
      <form name="alertForm" [formGroup]="alertForm" class="alert-form w-100-p" fxLayout="column" fxFlex>

        <mat-input-container class="w-100-p">

          <input matInput formControlName="subject" name="subject" placeholder="Subject">

          <mat-error>
            <eguard-validation-messages [control]="alertForm.controls.subject"></eguard-validation-messages>
          </mat-error>

        </mat-input-container>

        <mat-input-container class="w-100-p" *ngIf="casesArray.length > 1">

          <mat-select placeholder="Cases" formControlName="case_id">
            <mat-option *ngFor="let case of casesArray" [value]="case.id">
              {{ case.summary.case_number == null ? case.ward.name : case.summary.case_number}}
            </mat-option>
          </mat-select>

          <mat-error>
            <eguard-validation-messages [control]="alertForm.controls.case_id"></eguard-validation-messages>
          </mat-error>

        </mat-input-container>

        <mat-input-container class="w-100-p">

          <mat-select placeholder="Message Type" name="message_type" formControlName="message_type">
            <mat-option *ngFor="let messageTypeVal of messageTypes" [value]="messageTypeVal">
              {{ messageTypeVal}}
            </mat-option>
          </mat-select>

          <mat-error>
            <eguard-validation-messages [control]="alertForm.controls.message_type"></eguard-validation-messages>
          </mat-error>

        </mat-input-container>

        <mat-input-container class="w-100-p">

          <textarea rows="8" matInput formControlName="message" name="message" placeholder="Message" mat-maxlength="250"
            max-rows="4">
      </textarea>

          <mat-error>
            <eguard-validation-messages [control]="alertForm.controls.message"></eguard-validation-messages>
          </mat-error>

        </mat-input-container>

      </form>
    </div>

    <mat-table [dataSource]="uploadQueue" class="mat-elevation-z8" *ngIf="uploadQueue.data.length > 0">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name. </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="size">
        <mat-header-cell *matHeaderCellDef> Size </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ cleanFileSize(element.size) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ cleanFileType(element.type) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-raised-button color="warn" class="mat-icon-button" (click)="removeFile(element)">
            <i class="material-icons">delete</i>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

  </div>

  <div class="actionButtons">
    <input hidden type="file" #docUpload (change)="addToQueue($event)" />
    <button mat-button color="accent" matTooltip="Attach File" (click)="docUpload.click()">
      <i class="material-icons">attach_file</i>
    </button>
    <!-- <span type="button" class="mat-icon-button" matTooltip="Attach File" mat-raised-button color="accent" (click)="docUpload.click()"
      style="float:right;">
      <i class="material-icons">attach_file</i>
    </span> -->
    <button [class.loading]="loading" mat-raised-button color="accent" aria-label="Send" (click)="saveAlert()"
      [disabled]="alertForm.invalid || loading" style="float:right;">
      <div class="spinner"></div>
      <span class="label" style="text-transform: uppercase;">Create</span>
    </button>
    <!-- <button [class.loading]="loading" mat-raised-button aria-label="Send" (click)="dialogRef.close(false)"
      [disabled]="loading" style="text-transform: uppercase;">
      Cancel
    </button> -->
  </div>
  <br>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/alertForm/alertForm.component.html